import React, { useState } from "react";
import { useApolloClient } from "@apollo/client";
import { GET_STAND_TYPE_EQUIPMENTS_CURSOR } from "graphql/query/stand-gql";
import { GET_ME } from "graphql/query/user-gql";
import { useBreadCrumbs } from "components/use-hooks";
import { DrawerStandart, Localize } from "components/service";
import { localizeByKey } from "components/service/localize";
import { Tables } from "components/layout";
import Stand from "components/stand";
import Equipment from "components/equipment";
import type { TStand } from "components/stand/helpers/stand-types-helper";
import Icons from "components/icons";
import { PermissionButton } from "components/permissions";
import StandConst from "components/stand/stand-const";

interface IStandEquipmentsSubPageProps
{
  stand: TStand | undefined;
  lang: string;
}

const StandEquipmentsSubPage: React.FC<IStandEquipmentsSubPageProps> = ({ stand, lang }) =>
{
  const basePath = Stand.Const.basePath;
  const tableHelper = Stand.Helpers.TableEquipments;
  const client = useApolloClient();
  const cachedMe = client.readQuery({
    query: GET_ME,
  });

  const breadcrumbs = [
    {
      label: localizeByKey("BREADCRUMBS.Label_StandTypes"),
      path: `${basePath}`,
    },
    {
      label: stand?.title ?? localizeByKey("VARIABLE.Label_EMPTY"),
      path: `${basePath}/edit/${stand?.group_id}/${lang}`,
    },
    {
      label: localizeByKey("BREADCRUMBS.Label_Equipments"),
      path: `${basePath}/edit/${stand?.group_id}/${lang}/equipments`,
    },
  ];

  useBreadCrumbs(breadcrumbs);

  const [ variables, setVariables ] = useState<Record<string, any>>({});
  // const [ searchText, setSearchText ] = useState("");

  return (
    <Tables.Cursor
      model="standTypeEquipmentsCursor"
      query={GET_STAND_TYPE_EQUIPMENTS_CURSOR}
      tableHelper={tableHelper}
      language={cachedMe?.me?.lang_app}
      currentObj={stand}
      setVariables={setVariables}
      // searchText={searchText}
      objectWhere={{
        column: "STAND_TYPE_GROUP",
        operator: "EQ",
        value: parseInt(stand?.group_id ?? "0"),
      }}
    >
      <div className="table-action-bar">
        <div className="col"></div>

        <div className="col">
          <DrawerStandart
            extraClass={"modal-form filters"}
            modalButton={
              <PermissionButton
                permission={StandConst.permissions.UPDATE_EQUIPMENT}
                disabledFallback={true}
                type="primary"
                icon={<Icons.Plus />}
              >
                <span className="ellipsis">
                  <Localize>GLOBAL.Button_Text_AddNew</Localize>
                </span>
              </PermissionButton>
            }
          >
            <strong className="modal-title">
              <span className="text">
                <Localize>FORMS.Title_Text_AddEquipmentRule</Localize>
              </span>
            </strong>

            <Equipment.Forms.AddRule
              stand={stand}
              lang={cachedMe?.me?.lang_app}
              variables={variables}
              action={() => { }}
            />
          </DrawerStandart>
        </div>
      </div>
    </Tables.Cursor>
  );
};

export default StandEquipmentsSubPage;